var _defs, _polyline, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMountains02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#cecece;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:#cecece;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mountains02.sg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2 193 34.78 148.94 63 111"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63,
    y1: 111,
    x2: 123,
    y2: 195
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150,
    y1: 67,
    x2: 90,
    y2: 149
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 187,
    y1: 118,
    x2: 150,
    y2: 67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 236,
    y1: 22,
    x2: 176,
    y2: 103
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 297,
    y1: 105,
    x2: 236,
    y2: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90,200c-7,0-6,11-13,11-8,0-8-9-14-9s-5,9-13,9-5-11-13-11l27-37Z",
    transform: "translate(-1 -52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177,156c-7,0-6,11-13,11-8,0-8-9-14-9s-5,9-13,9-5-11-13-11l27-37Z",
    transform: "translate(-1 -52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263,111c-7,0-6,11-13,11-8,0-8-9-14-9s-5,9-13,9-5-11-13-11l27-37Z",
    transform: "translate(-1 -52)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236 21 236 2 255.53 2 248.67 8.33 255.53 12.56 236 12.56 236 21 236 21"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains02);
export default __webpack_public_path__ + "static/media/mountains02.7463c213ffdc897a66d883e4232b8f68.svg";
export { ForwardRef as ReactComponent };